import axios from "axios";
import User from "../models/user";
import authHeader from "@/services/auth-header";
import { ApiService } from "@/services/api.service";
import environments from "../utils/environments";

const API_URL = environments.apiUrl + "/api/rechnung/";

class RechnungService {
  getOpenRechnungen() {
    return ApiService.get(API_URL + "getopenrechnungen");
  }

  createOrUpdateRechnung(data: any, mode: number) {
    let restMethod = "createnewrechnung";
    if (mode == 1) {
      restMethod = "updaterechnung";
    }

    return ApiService.post(API_URL + restMethod, data);
  }

  getRechnungenForVendor(vendorId: number) {
    return ApiService.post(API_URL + "getrechnungenforvendor", { vendorId: vendorId });
  }

  deleteRechnung(selectedRechnungId: any) {
    return ApiService.post(API_URL + "deleterechnung", { rechnungId: selectedRechnungId });
  }
}

export default new RechnungService();
